import type { NodeV2Style } from '@vedalib/editor'
import * as R from 'ramda'

import { DEFAULT_AREA } from '../../constants'
import { safeParseGrid } from '../Grid/utils'
import type { IGridArea } from './types'

export const safeParseArea = (value?: string): IGridArea => {
  try {
    return JSON.parse(value || DEFAULT_AREA)
  } catch {
    return JSON.parse(DEFAULT_AREA)
  }
}

export const applyArea = (parent?: NodeV2Style | null, area?: Partial<IGridArea> | string) => {
  const parsedArea = typeof area === 'string' ? safeParseArea(area) : area || safeParseArea()
  const rows = safeParseGrid(parent?.gridRows).items.length
  const cols = safeParseGrid(parent?.gridColumns).items.length

  const rs = R.clamp(R.min(1, rows), R.max(1, rows), parsedArea?.rowStart) || 1
  const re = R.clamp(R.min(rs + 1, rows), R.max(rs + 1, rows + 1), parsedArea?.rowEnd) || 2

  const cs = R.clamp(R.min(1, cols), R.max(1, cols), parsedArea?.colStart) || 1
  const ce = R.clamp(R.min(cs + 1, cols), R.max(cs + 1, cols + 1), parsedArea?.colEnd) || 2

  return `${rs} / ${cs} / ${re} / ${ce}`
}

export const saveArea = (value: IGridArea) => JSON.stringify(value)
